import defaultApi from '@/utils/request';

export default {
  // ---------------------- S1CW4001 --------------------------------------
  // 加載列表
  S1CW4001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S1C/S1CW4001_Load',
      params,
    });
  },
  S1CW4001_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S1C/S1CW4001_Query',
      params,
    });
  },
  S1CW4001_GetPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S1C/S1CW4001_GetPDF',
      responseType: 'blob',
      params,
    });
  },
  // -----------------------------------------------------------------------------
  // ---------------------- S1CW4002 ---------------------------------------------
  // 加載列表
  S1CW4002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S1C/S1CW4002_Load',
      params,
    });
  },
  S1CW4002_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S1C/S1CW4002_Query',
      params,
    });
  },
  S1CW4002_GetPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S1C/S1CW4002_GetPDF',
      responseType: 'blob',
      params,
    });
  },
  // -----------------------------------------------------------------------------
  // ---------------------- S1CW4003 --------------------------------------
  // 加載列表
  S1CW4003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S1C/S1CW4003_Load',
      params,
    });
  },
  S1CW4003_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S1C/S1CW4003_Query',
      params,
    });
  },
  S1CW4003_GetPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S1C/S1CW4003_GetPDF',
      responseType: 'blob',
      params,
    });
  },
  // -----------------------------------------------------------------------------
};
